import React from 'react';
import cx from 'classnames';

import { Typography as AntTypography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';

import styles from './Typography.module.scss';

export interface ITypographyTitleProps extends TitleProps {
  noMargin?: boolean;
  weight?: 'regular' | 'semibold';
}

export const TypographyTitle: React.FC<ITypographyTitleProps> = (props) => {
  const { noMargin, weight = 'semibold', className } = props;

  return (
    <AntTypography.Title
      className={cx(
        styles.Title,
        {
          'no-margin': noMargin,
          'weight-regular': weight === 'regular',
        },
        className
      )}
      {...props}
    />
  );
};
